// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"579":"e5cfc399","716":"6455d28d","838":"2e7d994c","946":"fd5c8794"}[chunkId] + ".chunk.css";
};